import { render } from "./UsedTickets.vue?vue&type=template&id=8dfa7722&scoped=true"
import script from "./UsedTickets.vue?vue&type=script&lang=js"
export * from "./UsedTickets.vue?vue&type=script&lang=js"

import "./UsedTickets.vue?vue&type=style&index=0&id=8dfa7722&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfa7722"]])

export default __exports__